export default "__VITE_ASSET__vG9LYBf4__"